module.exports = __webpack_public_path__ + "img/enaq_logo.4e3420ab.png";